import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Svg from 'react-inlinesvg';
import { sortDescendingIcon } from '../../images';
import { colors, verticalGutter } from '../../styles';

const StyledSortIcon = styled.span`
  display: inline-block;
  color: ${colors.textColor};
  text-decoration: none !important;
  svg {
    transform: scaleY(${({ isDesc }) => (isDesc ? -1 : 1)});
    margin-left: ${verticalGutter / 4}rem;
    g {
      fill: ${({ active }) => (active ? colors.primary : colors.grey)};
    }
  }
`;

const SortIcon = ({ active, isDesc, children }) =>
  children ? (
    <StyledSortIcon
      role="button"
      active={active}
      isDesc={isDesc}
      className="text--nowrap"
    >
      {children}
      <Svg src={sortDescendingIcon} />
    </StyledSortIcon>
  ) : null;

SortIcon.propTypes = {
  active: PropTypes.bool,
  isDesc: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
export default SortIcon;



// WEBPACK FOOTER //
// ./src/components/SortIcon/SortIcon.js